<div class="actionpopuup">
  <h3>{{ 'ADMIN_CONFIGURATION.DELETE_ALERT_TITLE' | translation }}</h3>
  <span class="description">{{ 'ADMIN_CONFIGURATION.DELETE_ALERT_DESCRIPTION' | translation }} <strong>{{ data.user.name }} {{ data.user.lastName }}</strong>?</span>
  <div class="actions">
    <button mat-raised-button class="outlined-button" type="button" [mat-dialog-close]="false"> {{ 'CANCEL' | translation }} </button>
    <button mat-raised-button [disabled]="loading" class="outlined-button" type="button" (click)="deleteAdmin()"> {{ 'YES_DELETE' | translation }} </button>
  </div>
</div>
